import React from 'react'
import { StyleSheet } from 'react-native'
import { Spacing, Text, TextProps } from 'zens-storybook'
import { useLocation } from 'zens-store'

const styles = StyleSheet.create({
  container: {
    marginTop: Spacing.XS,
  },
})

interface Props extends TextProps {
  value: number
  companyId: number
}
const LocationField = (props: Props) => {
  const { value: locationId, companyId, style, ...otherProps } = props
  const location = useLocation({
    companyId,
    locationId,
  })
  return (
    <Text style={[styles.container, style]} {...otherProps}>
      {location.data?.displayName}
    </Text>
  )
}

export default LocationField
